<template>
  <div>
    <v-simple-table class="mx-5">
      <template v-slot:default>
        <thead>
          <tr>
            <th v-if="lineNumbers" class="font-weight-bold text-center">STT</th>
            <th class="text-center" style="width:10px">
              <v-checkbox v-if="selectOption" v-model="checkall"></v-checkbox>
            </th>
            <th
              v-for="column in columns"
              :key="'th' + column.field"
              :class="column.thClass ? column.thClass : 'text-center'"
              class="font-weight-bold"
              :style="{
                width: column.thWidth ? column.thWidth : '',
                height: column.thHeight ? column.thHeight : '',
              }"
            >
              {{ column.label }}
              <v-btn
                v-if="column.sort"
                icon
                @click="$emit('sort', column.field)"
              >
                <div style="display: flex; flex-direction: column">
                  <v-icon
                    :style="{
                      color: ['asc', 1].includes(sortField[`${column.field}`])
                        ? '#e91e63'
                        : '',
                    }"
                    style="height: 12px; font-size: 25px"
                    >mdi-menu-up</v-icon
                  >
                  <v-icon
                    :style="{
                      color: ['desc', -1].includes(sortField[`${column.field}`])
                        ? '#e91e63'
                        : '',
                    }"
                    style="height: 12px; font-size: 25px"
                    >mdi-menu-down</v-icon
                  >
                </div>
              </v-btn>
            </th>
          </tr>
        </thead>
        <tbody v-if="rows.length">
          <tr v-for="(item, index) in rows" :key="'row' + index">
            <td v-if="lineNumbers" class="text-center">
              {{ (page * 20 - 20) + (index + 1) }}
            </td>
            <td v-if="selectOption">
              <v-checkbox
                :key="'cbtd' + index"
                v-model="selectedList"
                :value="item"
              ></v-checkbox>
            </td>

            <td
              v-for="column in columns"
              :key="'td' + column.field"
              :class="column.tdClass ? column.tdClass : 'text-left'"
            >
              <span v-if="column.field.split('.').length === 2">
                {{
                  item[`${column.field.split(".")[0]}`][
                    `${column.field.split(".")[1]}`
                  ]
                }}
              </span>
              <div v-else-if="column.field === 'actions'">
                <slot name="action" v-bind="item" />
              </div>
              <div v-else-if="column.customRow">
                <slot :name="column.field" v-bind="item" />
              </div>
              <span v-else>
                <span v-if="item[`${column.field}`]">
                  {{
                    column.type === "date"
                      ? formatDateSpan(column, item[`${column.field}`])
                      : item[`${column.field}`]
                  }}
                </span>
                <span v-else>-</span>
              </span>
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td
              colspan="10"
              class="scroll-layout-left"
              :style="'left:' + sticky_id"
            >
              <common-no-result />
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <div class="d-flex justify-end mx-3 my-2">
      <div style="width: fit-content">
        <v-pagination
          v-model="value"
          :length="totalPage"
          :total-visible="totalPage < 7 ? totalPage : 7"
        ></v-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ShortLinkTable",
  props: {
    rows: {
      type: Array,
      default: () => [],
    },
    columns: {
      type: Array,
      default: () => [],
    },
    totalPage: {
      type: Number,
      default: 0,
    },
    page: {
      type: Number,
      default: 1,
    },
    sortField: {
      type: Object,
      default: () => {},
    },
    lineNumbers: {
      type: Boolean,
      default: false,
    },
    selectOption: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      value: 1,
      checkall: false,
      selectedList: [],
    };
  },
  watch: {
    rows(val) {
      if (val) {
        this.selectedList = [];
      }
    },
    page(val) {
      this.value = val;
      this.checkall = false;
      this.selectedList = []
    },
    value(val) {
      this.$emit("pagination", val);
    },
    checkall(val) {
      if (val) {
        this.selectedList = []
        this.selectedList = [...this.rows]
      } else {
        this.selectedList = this.selectedList.length === this.rows.length ? [] : this.selectedList
      }
    },
    selectedList(val) {
      if( val ) {
        if(val.length === this.rows.length) {
          this.checkall = true
        } else {
          this.checkall = false
        }
        this.$emit('onSelectedRowsChange',val)
      } else {
        this.$emit('onSelectedRowsChange',[])
      }
    },
  },
  methods: {
    formatDateSpan(column, date) {
      if (column.format && column.format === "YYYY-MM-DD HH:mm") {
        return this.customFormatDateTime(date);
      } else {
        return this.formatDate(date);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
table {
  th,
  td {
    border: 1px solid #d2d2d2;
    padding: 0px 8px;
  }
}
</style>